import type * as React from "react";
import { Box } from "@mui/material";
import HeaderLogo from "assets/images/GL-Logo.svg";
import AccountExitLink from "components/v3/sharedComponents/AccountExitLink";
import Stepper from "components/v3/sharedComponents/Stepper";
import { PATHS } from "constants/pathConstants";

export interface GiftCheckoutStepperProps {
  activeStepIndex: number;
  giftCount?: number;
}

type SubStep = {
  label: string;
  stepIndex: number;
};

type Step = {
  longName: string;
  shortName: string;
  stepIndex: number;
  subSteps: SubStep[];
};

const GiftCheckoutStepper: React.FC<GiftCheckoutStepperProps> = ({
  activeStepIndex,
  giftCount = 1
}) => {
  const buyGiftStepLabel = giftCount > 1 ? "Buy Gifts" : "Buy Gift";

  const steps: Step[] = [
    {
      longName: "Add Gift Recipients",
      shortName: "Add Gift Recipients",
      stepIndex: 0,
      subSteps: []
    },
    {
      longName: buyGiftStepLabel,
      shortName: buyGiftStepLabel,
      stepIndex: 1,
      subSteps: []
    }
  ];

  const greeting = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: (theme) => `calc(${theme.spacing(2)} + 15px)`,
        paddingTop: { md: "15px", xs: "calc(8px + 15px)" },
        width: "100%"
      }}
    >
      <AccountExitLink to={PATHS.ACCOUNT_MANAGEMENT_GIFT_MEMBERSHIP} />
      <Box sx={{ maxWidth: 175, width: "100%" }}>
        <Box
          alt="Genomic Life"
          component="img"
          src={HeaderLogo}
          sx={{ height: "auto", maxWidth: "100%" }}
        />
      </Box>
    </Box>
  );

  return (
    <Stepper
      activeStepIndex={activeStepIndex}
      greeting={greeting}
      headerShown
      horizontalStripSurface="transparent"
      layout="horizontal"
      showMobileGreeting
      steps={steps}
    />
  );
};

export default GiftCheckoutStepper;
